import { canv } from '@/canv/global.js'
import { sleep } from '@/canv/utils.js';
import { getViewport } from '@/canvasController/helpers';

export class shapeLibraryWindow {
    constructor() {

    }


    async show() {

        var shapeLibraryWindow = document.createElement('div');
        shapeLibraryWindow.classList.add("shapeLibraryWindow");
        document.body.prepend(shapeLibraryWindow);

        shapeLibraryWindow.innerHTML = this.getPanel();
        this.fillPanel();
        this.init();

        await sleep(10);
        shapeLibraryWindow.style.marginLeft = "0px";
    }

    init() {

        var shapes = document.getElementsByClassName("shapeLibraryWindowContentBlockContainerItem");
        for (var i = 0; i < shapes.length; i++) {
            var mode =  shapes[i].getAttribute("mode");
            shapes[i].addEventListener('mouseup', this.chooseMode.bind(this, mode), false);
        }
    }

    async chooseMode(mode) {
        var shapeTool = canv.toolBox.TryGetToolByName("shapeTool");
        shapeTool.setMode(mode);
        var newShapeWrapper = shapeTool.getWidgetWrapper();

        var viewport = getViewport();
        var positionX = viewport["viewportStartX"] + viewport["viewportWidth"] / 2 - newShapeWrapper.startX - newShapeWrapper.width / 2;
        var positionY = viewport["viewportStartY"] + viewport["viewportHeight"] / 2 - newShapeWrapper.startY - newShapeWrapper.height / 2;
        newShapeWrapper.translateGroup(positionX, positionY);

        canv.canvasController.addGroup(newShapeWrapper);
        canv.eventManager.openRecord();
        canv.eventManager.createBuildEvent("create", newShapeWrapper);
        canv.eventManager.closeRecord();
        canv.toolBox.TryGetToolByName("cursorTool").setSelectedAndInteraction(newShapeWrapper);
    }

    getPanel() {
        return `
            <div class="shapeLibraryWindowContent scrollable">

            </div>
        `;
    }

    fillPanel() {
        var shapeLibraryWindowContent = document.getElementsByClassName("shapeLibraryWindowContent")[0];

        var basic = ["rect", "circle", "roundedRect", "rombus", "triangle", "downTriangle", "RSkewRect", "LSkewRect", "bubble", "arrowRight", "arrowLeft", "arrowLeftRight", "pentagon", "octagon", "hexagon", "predefinedProcess", "trapezoid", "cross", "braceLeft", "braceRight"];
        shapeLibraryWindowContent.innerHTML += this.getBlock("Базовые", basic);

        var flowchart = ["roundedRect", "rombus", "pentagon", "predefinedProcess", "document", "manualInput", "hexagon", "RSkewRect", "LSkewRect", "database", "directAccessStorage", "internalStorage", "manualOperation", "delay", "storedData", "merge", "circle", "or", "display", "offPageConnector"];
        shapeLibraryWindowContent.innerHTML += this.getBlock("Диаграммы", flowchart);
    }

    getBlock(title, shapesList) {

        var shapes = ``;

        for (var i = 0; i < shapesList.length; i++) {
            shapes += this.getShapeItem(shapesList[i]);
        }

        var template = `
            <div class="shapeLibraryWindowContentBlock">
                <p class="shapeLibraryWindowContentBlockTitle">` + title + `</p>
                <div class="shapeLibraryWindowContentBlockContainer">
                    ` + shapes + `
                <div>
            </div>
        `;

        return template;
    }

    getShapeItem(shape) {
        return `
            <div class="shapeLibraryWindowContentBlockContainerItem" mode=` + shape + `>
                ` + canv.shapeStorage.getShape(shape).getView("shapeLibrary") + `
            </div>
        `;
    }

    async hide() {
        var shapeLibraryWindow = document.getElementsByClassName("shapeLibraryWindow")[0];
        if (shapeLibraryWindow == undefined) return;
        shapeLibraryWindow.outerHTML = "";
    }


}
